import axios from "axios";

/**
 * True if logged in, false otherwise
 * @returns {Promise<axios.AxiosResponse<boolean>>}
 */
export function getLoginStatus() {
  return axios.get("/sewp5public/user/login-status");
}